import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import styles from "./Home.module.sass";
import TooltipGlodal from "../../components/TooltipGlodal";
import TopBar from "./TopBar";
import Kpis from "./Kpis";
import Inbox from "./Inbox";
import AiDrafts from "./AiDrafts";
import GamesDaily from "./GamesDaily";
import PopularDecksReal from "./PopularDecksReal";
import RecentGames from "./RecentGames";
import { fetchInbox, fetchOverview, fetchPopularDecks } from "../../app/stats/stats.slice";

const Home = () => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((s) => s.user.value);
  useEffect(() => {
    dispatch(fetchOverview());
    dispatch(fetchPopularDecks(5));
    dispatch(fetchInbox());
  }, [dispatch]);

  const hour = new Date().getHours();
  const greeting =
    hour < 12
      ? t("home.greeting.morning", "Buenos días")
      : hour < 20
      ? t("home.greeting.afternoon", "Buenas tardes")
      : t("home.greeting.night", "Buenas noches");
  const firstName = String(user?.name || user?.username || "")
    .split(/\s+/)
    .filter(Boolean)[0];
  const locale = (i18n.language || "es").startsWith("es") ? "es-ES" : "en-US";
  const dateStr = new Date().toLocaleDateString(locale, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });

  return (
    <>
      <TopBar />
      <div className={styles.hero}>
        <h1 className={styles.title}>
          {greeting}
          {firstName ? `, ${firstName}` : ""} <span className={styles.wave}>👋</span>
        </h1>
        <div className={styles.subtitle}>{dateStr.charAt(0).toUpperCase() + dateStr.slice(1)}</div>
      </div>
      <Kpis className={styles.card} />
      <div className={styles.row}>
        <div className={styles.col}>
          <GamesDaily className={styles.card} />
          <Inbox className={styles.card} />
          <AiDrafts className={styles.card} />
        </div>
        <div className={styles.col}>
          <PopularDecksReal className={styles.card} />
          <RecentGames className={styles.card} />
        </div>
      </div>
      <TooltipGlodal />
    </>
  );
};

export default Home;
